/*
 * <copyright company="Argenbright Innovations Lab">
 *        copyright (c) Argenbright Innovations Lab, an Argenbright Holdings Company.  All rights reserved.
 * </copyright>
 */
import { useTranslation } from 'react-i18next';
import { ListItemButton, ListItemIcon } from '@mui/material';

import { styles, TextStyle } from './LeftNavBar.styles';
import { Icons } from '../../../Constants/Icons';

interface ILanguageSwitcherProps {
  theme: any;
  handleMenuClick: () => void;
  isActive: boolean;
}

const AllJobsMenu = ({ theme, handleMenuClick, isActive }: ILanguageSwitcherProps): JSX.Element => {
  const { t } = useTranslation(['homePage', 'jobManagement']);

  return (
    <ListItemButton
      onClick={handleMenuClick}
      sx={{
        '&:hover': {
          backgroundColor: theme.palette.primary.main,
          fontWeight: theme.typography.fontWeightBold,
        },
        backgroundColor: isActive ? theme.palette.primary.main : 'transparent',
        fontWeight: isActive ? theme.typography.fontWeightBold : 'normal',
        padding: '1rem',
        borderRadius: '1rem',
        marginBottom: '0.5rem',
        alignItems: 'flexStart',
        justifyContent: 'flexStart',
        width: '100%',
      }}>
      <ListItemIcon
        sx={{
          ...styles.iconStyle,
        }}>
        <img src={Icons.AllJobsIcon} alt={t('homePage:languageSwitcher')} />
      </ListItemIcon>
      <TextStyle>{t('jobManagement:changeVendor')}</TextStyle>
    </ListItemButton>
  );
};

export default AllJobsMenu;
